const formData = {
    continueReport: [
        {
            key: 'accessor_group_id',
            type: 'select',
            value: '',
            valid: false,
            hasDesc: true,
            elementConfig: {
                name: 'assessor_group__assessor_name',
                label: 'Relation to me',
                options: [],
                storeKey: ['AsessorGroupList', 'assessor_group_list', 'data', 'organisation_assessor_group_list']
            },
            validation: {
                required: true,
                message: "is required"
            } 
        },
        {
            type: 'desc',
        },
        {
            is_email: true,
            key: 'email_id',
            // type: 'commaSeparate',
            type: 'textarea',
            value: '',
            valid: false,
            commaSepareted: true,
            textBelowInput: '<p style="text-align: center; font-size: 12px; color: #8a5e5e;">(You can enter multiple IDs as comma-separated values.)</p>',
            // ^[A-Za-z0-9](([_\.\+\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$
            regex: '',
            elementConfig: {
                name: 'email',
                label: 'Email ID',
                placeholder: 'name@company.com'
            },
            validation: {
                required: true,
                // message: "Separate Email with a comma or press Enter"
                message: "Enter a Valid Email"
            }
        },{
            type: 'multiple_email_error',
            value: ''
        }
    ],
    Edit: [
        {
            key: 'respondent__full_name',
            type: 'paraText',
            value: '',
            valid: true,
            regex: ".+",
            elementConfig: {
                name: 'respondent__full_name',
                label: 'Name',
            },
            validation: {
                required: false,
                message: "is required"
            },
        },
        {
            key: 'respondent__email',
            type: 'paraText',
            value: '',
            valid: true,
            regex: ".+",
            elementConfig: {
                name: 'respondent__email',
                label: 'Email',
            },
            validation: {
                required: false,
                message: "is required"
            },
        },
        {
            key: 'accessor_group_id',
            type: 'select',
            value: '',
            valid: false,
            elementConfig: {
                name: 'assessor_group__assessor_name',
                label: 'Relation to me',
                options: [],
                storeKey: ['AsessorGroupList', 'assessor_group_list', 'data', 'organisation_assessor_group_list']
            },
            validation: {
                required: true,
                message: "is required"
            } 
        },
    ]
}

export default formData


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/formdata.js